import { Record } from "immutable";
import { RecordUtils } from "@rsm-hcd/javascript-core";
import type { NotebookPromptSuggestions } from "models/interfaces/conversations/prompt-suggestions/prompt-suggestions";
import PromptSuggestionRecord from "./prompt-suggestion-record";

const defaultValues: NotebookPromptSuggestions = {
    page: [],
    block: [],
};

export default class NotebookPromptSuggestionsRecord
    extends Record(defaultValues)
    implements NotebookPromptSuggestions
{
    constructor(params?: Partial<NotebookPromptSuggestions>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.page != null) {
            RecordUtils.ensureRecords(params.page, PromptSuggestionRecord);
        }
        if (params.block != null) {
            RecordUtils.ensureRecords(params.block, PromptSuggestionRecord);
        }

        super(params);
    }
}
